import officeTypeOptions from 'packages/service_repository/utils/officeTypes';
import { ManagedStartupType } from '../types';
import {
  PortalOrder, PortalRequestItem, PortalScope, PricedPortalService,
} from './types';

export const isEligibleProvider = (name?: string) => (
  ['clara', 'clara formations limited', 'wework'].includes((name || '').trim().toLowerCase())
);

export const selectedStartup = (startups: ManagedStartupType[], value?: string | number) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? startups.find((startup) => startup.id === id) : undefined;
};

export const orderPrice = (service: PricedPortalService, order: Pick<PortalOrder, 'quantity' | 'desks'>) => {
  const { quantity, desks = 1 } = order;
  const rate = service.servicePrice.toPrice;
  if (!Number.isFinite(quantity) || quantity < 1 || !Number.isFinite(desks) || desks < 1
    || rate === undefined || !Number.isFinite(rate) || rate < 0) {
    throw new Error('Check the quantity and service price');
  }
  const total = rate * quantity * (service.categoryID === 1 ? desks : 1);
  if (!Number.isFinite(total)) throw new Error('Invalid order total');
  return Math.round(total * 100) / 100;
};

export const officeRequestDetails = (item: PortalRequestItem): string | undefined => {
  try {
    const details = JSON.parse(item.details || '{}');
    const officeType = officeTypeOptions.find(({ value }) => value && value === details?.officeType);
    if (!officeType || !Number.isInteger(details.noOfDesk) || details.noOfDesk < 1) return undefined;
    return `${officeType.label} · ${details.noOfDesk} desk(s) · ${item.quantity} month(s)`;
  } catch {
    return undefined;
  }
};

export const portalKeys = {
  scope: (scope: PortalScope) => ['ventureBuilderPortal', scope.userId, scope.ventureBuilderId],
  portfolio: (scope: PortalScope) => [...portalKeys.scope(scope), 'portfolio'],
  services: (scope: PortalScope) => [...portalKeys.scope(scope), 'services'],
  service: (scope: PortalScope, id: number) => [...portalKeys.scope(scope), 'service', id],
  requests: (scope: PortalScope, startupId: number) => [...portalKeys.scope(scope), 'requests', startupId],
  items: (scope: PortalScope, startupId: number, id: number) => [...portalKeys.requests(scope, startupId), 'items', id],
};

// Compare the reviewed content, not just its total (different services can cost the same).
export const draftFingerprint = (items: PortalRequestItem[]) => JSON.stringify(
  [...items].sort((a, b) => a.id - b.id).map((item) => [
    item.id, item.serviceRequestID, item.serviceID || item.service?.id, item.servicePriceID,
    item.quantity, item.price, item.details || '',
  ]),
);

export class UncertainOrderError extends Error {
  constructor() {
    super('Saving could not be confirmed. Review Requests before adding this service again');
  }
}

export const requestStatusLabels: Record<number, string> = {
  1: 'Draft',
  2: 'Pending quotation',
  3: 'Quoted',
  4: 'Pending HUB71 approval',
  5: 'In progress',
  6: 'Rejected',
  7: 'Delivered',
  8: 'Failed to deliver',
};
